import lineStyle from './pie.data.labelLine.lineStyle'

export default {
  name: "labelLine",
  nickname: "引导线样式",
  desc: "labelLine",
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示视觉引导线。",
    },
    length: {
      name: "length",
      nickname: "长度",
      desc: "视觉引导线第一段的长度。",
    },
    length2: {
      name: "length2",
      nickname: "视觉引导项第二段的长度",
      desc: "视觉引导项第二段的长度。",
    },
    smooth: {
      name: "smooth",
      nickname: "平滑",
      desc:
        '是否平滑视觉引导线，默认不平滑，可以设置成 <code class="codespan">true</code> 平滑显示，也可以设置为 0 到 1 的值，表示平滑程度。',
      value: false,
      defaultValue: false,
    },
    lineStyle,
  },
}
